export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wsWorker.worker.ac76c02e.worker.js");
}
